import { Injectable } from '@angular/core';
import { AgentType, PromptType, Agent } from '../models';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class AgentMappingsService {
  private readonly agentNames: Record<AgentType, string> = {
    [AgentType.PYSPARK_AGENT]: 'PySpark Agent',
    [AgentType.SPARK_SQL_AGENT]: 'SparkSQL Agent',
    [AgentType.UNIVERSAL_CODER_AGENT]: 'Universal Coder Agent',
    [AgentType.CHAT_AGENT]: 'Chat Assistant',
  };

  private readonly agentTypeLabels: Record<AgentType, string> = {
    [AgentType.PYSPARK_AGENT]: 'PYSPARK',
    [AgentType.SPARK_SQL_AGENT]: 'SPARK SQL',
    [AgentType.UNIVERSAL_CODER_AGENT]: 'UNIVERSAL',
    [AgentType.CHAT_AGENT]: 'CHAT',
  };

  private readonly agentLanguages: Record<AgentType, string> = {
    [AgentType.PYSPARK_AGENT]: 'python',
    [AgentType.SPARK_SQL_AGENT]: 'sql',
    [AgentType.UNIVERSAL_CODER_AGENT]: 'python',
    [AgentType.CHAT_AGENT]: 'text',
  };

  private readonly promptTypeLabels: Record<PromptType, string> = {
    [PromptType.SPARK_SQL_EXPRESSIONS]: 'Spark SQL Expressions',
    [PromptType.SPARK_SQL_CODE]: 'Spark SQL Code',
    [PromptType.PYSPARK_CODE]: 'PySpark Code',
  };

  constructor(private readonly translateService: TranslateService) {}

  public getAgentDisplayName(agentType?: AgentType, selectedAgent?: Agent | null): string {
    if (!agentType) return this.translateService.instant('chat.agents.default-assistant-name');

    if (selectedAgent && selectedAgent.type === agentType) {
      return selectedAgent.name;
    }

    return this.agentNames[agentType] || 'AI Assistant';
  }

  public getAgentTypeLabel(agentType?: AgentType): string {
    if (!agentType) return '';
    return this.agentTypeLabels[agentType] || '';
  }

  public getLanguageFromAgentType(agentType?: AgentType): string {
    if (!agentType) return 'text';
    return this.agentLanguages[agentType] || 'text';
  }

  public getPromptTypeLabel(type: PromptType): string {
    return this.promptTypeLabels[type] || 'Spark SQL Expressions';
  }
}
